import { GoUpload, GoPersonFill, GoProject, GoDatabase, GoLaw, GoChecklist } from "react-icons/go";
import { BiTransfer } from "react-icons/bi";
import { MdInventory } from "react-icons/md";
import { FiShield, FiFileText, FiDownload, FiKey, FiTruck, FiUsers, FiDollarSign, FiTarget, FiMail, FiClipboard } from "react-icons/fi";

/**
 * Lista centralizada de módulos do sistema Vidal.
 * Fonte única de verdade para: menu, permissões, modais de projeto e usuário.
 *
 * - `id`: chave de permissão (usada em user.permissions e project.permissions)
 * - `dashboardId`: id da tela no menu (pode diferir do id de permissão)
 * - `label`: nome exibido na UI
 * - `icon`: componente react-icons
 * - `color`: cor de destaque
 * - `section`: agrupamento (dashboards | tools | settings)
 */
export const SYSTEM_MODULES = [
  // ── Dashboards ──
  { id: 'files',        dashboardId: 'files',               label: 'Arquivos',             icon: GoUpload,     color: '#3b82f6', section: 'dashboards' },
  { id: 'transactions', dashboardId: 'transactions',        label: 'Movimentações',        icon: BiTransfer,   color: '#8b5cf6', section: 'dashboards' },
  { id: 'monitoring',   dashboardId: 'notificacoes-fiscais', label: 'Notificações Fiscais', icon: FiShield,     color: '#10b981', section: 'dashboards' },
  { id: 'products',     dashboardId: 'products',            label: 'Produtos',             icon: MdInventory,  color: '#f59e0b', section: 'dashboards' },
  { id: 'clients',      dashboardId: 'clients',             label: 'Clientes',             icon: GoPersonFill, color: '#ef4444', section: 'dashboards' },
  { id: 'suppliers',    dashboardId: 'suppliers',           label: 'Fornecedores',         icon: FiTruck,      color: '#06b6d4', section: 'dashboards' },
  { id: 'reforma_tributaria', dashboardId: 'reforma-tributaria', label: 'Reforma Tributária', icon: GoLaw,   color: '#10b981', section: 'dashboards' },
  { id: 'validacao_fiscal', dashboardId: 'validacao-fiscal',   label: 'Validação Fiscal',    icon: GoChecklist, color: '#0ea5e9', section: 'dashboards' },
  { id: 'plcom',         dashboardId: 'plcom',               label: 'PLCom',                icon: FiClipboard, color: '#0ea5e9', section: 'dashboards' },
  // ── Tools ──
  { id: 'sped',         dashboardId: 'sped-reviewer',       label: 'Revisor SPED',         icon: FiFileText,   color: '#8b5cf6', section: 'tools' },
  { id: 'xml',          dashboardId: 'downloads',           label: 'Download XML',         icon: FiDownload,   color: '#10b981', section: 'tools' },
  { id: 'xml_scan',     dashboardId: 'xml-scan',            label: 'XML Scan',             icon: FiTarget,     color: '#f59e0b', section: 'tools' },
  { id: 'creditos',     dashboardId: 'creditos',            label: 'Créditos',             icon: FiDollarSign, color: '#06b6d4', section: 'tools' },
  { id: 'certificates', dashboardId: 'certificates',        label: 'Certificados',         icon: FiKey,        color: '#f59e0b', section: 'tools' },
  { id: 'email_marketing', dashboardId: 'email-marketing',  label: 'Email Marketing',      icon: FiMail,       color: '#ec4899', section: 'tools' },
  { id: 'questionario_fornecedores', dashboardId: 'automec-fornecedores', label: 'Questionário Fornecedores', icon: FiClipboard, color: '#14b8a6', section: 'tools' },
  // ── Settings ──
  { id: 'users',        dashboardId: 'users',               label: 'Usuários',             icon: FiUsers,      color: '#3b82f6', section: 'settings' },
  { id: 'projects',     dashboardId: 'projects',            label: 'Projetos',             icon: GoProject,    color: '#8b5cf6', section: 'settings' },
  { id: 'settings',     dashboardId: 'admin',               label: 'Admin',                icon: GoDatabase,   color: '#ef4444', section: 'settings' },
];

export const SECTION_LABELS = {
  dashboards: 'Dashboards',
  tools: 'Ferramentas',
  settings: 'Configurações',
};

/**
 * Mapeia dashboardId → permission module id.
 * Usado pelo menu para checar hasPermission.
 */
export const DASHBOARD_TO_MODULE = Object.fromEntries(
  SYSTEM_MODULES.map(m => [m.dashboardId, m.id])
);

/**
 * Retorna módulos filtrados por seção.
 */
export const getModulesBySection = (section) =>
  SYSTEM_MODULES.filter(m => m.section === section);
